import React, { useEffect, useState } from "react";
import { getRequest } from "../../utils/httpRequest";
import { AxiosResponse } from "axios";

interface PermissionData {
  message: string;
  type: string;
  url: string;
}

const Permission: React.FC = () => {
  const [permission, setPermission] = useState<PermissionData | null>(null);

  useEffect(() => {
    const fetchPermissions = () => {
      getRequest("api/permissions")
        .then((response: AxiosResponse<PermissionData>) => {
          console.log("some response peope", response);
          setPermission(response.data);
        })
        .catch((error) => {
          console.error("Error fetching permissions:", error);
        });
    };
    fetchPermissions();
  }, []);

  return (
    <div className="ui facelift-landing-page" id="login">
      <div className="ui container">
        <div className="wrapper">
          <div className="eight wide column section-two" id="column">
            <div className="ui facelift-landing-page">
              {permission ? (
                <>
                  <p className="permission-message">{permission.message}</p>
                  <a href={permission.url} className="block ui button primary">
                    {permission.type}
                  </a>
                </>
              ) : (
                <div>Loading...</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Permission;
